import { axios, toCamelCase, toSnakeCase } from '@utils';
import userService from '@services/user.service';

const {
  removeAvatar, notificationSettings, getUserNavData, updateName,
} = userService;

async function updateUserContact(userObj) {
  const user = await userService.updateUserContact(userObj);
  return user;
}

async function updateUser(userObj) {
  const user = await userService.updateUser(userObj);
  return user;
}

async function updateNotificationSettings({ phoneNumber, contactPreferenceSms, notifications }) {
  const response = await axios.patch('/api/v1/provider_users/update_notification_settings', {
    phone_number: phoneNumber,
    contact_preference_sms: contactPreferenceSms,
    notifications,
  });
  return toCamelCase(response.data);
}

async function getUser() {
  const user = await userService.getUser();
  const {
    openingsContactDetailsFirstName,
    openingsContactDetailsLastName,
    openingsContactDetailsEmail,
    openingsContactDetailsPhoneNumber,
    openingsContactDetailsTitle,
    ...rest
  } = user;
  return {
    ...rest,
    openingsContactDetails: {
      firstName: openingsContactDetailsFirstName,
      lastName: openingsContactDetailsLastName,
      email: openingsContactDetailsEmail,
      phoneNumber: openingsContactDetailsPhoneNumber,
      title: openingsContactDetailsTitle,
    },
  };
}

async function confirmNewFeeStructure(providerId) {
  const response = await axios.put(`/api/v1/providers/${providerId}/confirm_new_fee_structure`);
  return toCamelCase(response.data);
}

async function fetchSiteWideSearchResults({ query }) {
  const url = `/api/v1/providers/search?q=${query}`;
  const response = await axios.get(url);
  return toCamelCase(response.data);
}

async function fetchMrktUpdates(providerId, centerId) {
  const url = `/api/v1/providers/${providerId}/mrkt_updates?center_id=${centerId}`;
  const response = await axios.get(url);
  return toCamelCase(response.data);
}

async function updateProvider(providerId, providerObj) {
  const response = await axios.put(`/api/v1/providers/${providerId}`, toSnakeCase(providerObj));
  return toCamelCase(response.data.provider);
}

export {
  removeAvatar, updateNotificationSettings, getUser, updateUser, notificationSettings,
  getUserNavData, confirmNewFeeStructure, fetchSiteWideSearchResults,
  updateUserContact, updateName, fetchMrktUpdates, updateProvider,
};
